import React from 'react';

const Section = ({ 
    children, 
    id,
    isMobile = false, 
    isTablet = false, 
    isDesktop = false, 
    style, 
    className,
    ...props 
}) => {
    return (
        <section id={id} className={className} style={style} {...props}>
            {children}
        </section>
    );
};

export default Section;

